import { status } from '@/helpers/async';
import { INVALIDATE as AUTH_INVALIDATE } from '@/store/actions/auth';
import {
    bookmarkedEvents,
    SET_BOOKMARKED,
    FETCH,
    FILTER_UNBOOKMARKED,
    CLEAR_BOOKMARKS,
    REMOVE_BOOKMARK
} from '@/store/actions/eventBookmarks';

/* */
// Helpers
const lookupHashForBookmark = (bookmark) => ({
    eventId: bookmark,
    id: bookmark.id
});

const lookupHashForBookmarks = (eventBookmarks) =>
    eventBookmarks.reduce((memo, bookmark) => {
        memo[bookmark.eventId] = lookupHashForBookmark(bookmark);
        return memo;
    }, {});

// TODO: SPECIFIC Types
const eventsSort = (a, b) => a.startDate > b.startDate;

const initialState = {
    /** Easy lookup hash to check if a event is bookmarked or not. */
    hash: {},
    /**
     * Array of bookmarked events. Events only get removed from this on
     * FILTER_UNBOOKMARKED to allow the user to re-bookmark an un-bookmarked
     * event.
     */
    events: []
};

export default (state = initialState, action) => {
    switch (action.type) {
        case SET_BOOKMARKED: {
            const { eventId, isBookmarked } = action.data;
            const addEvent = isBookmarked;
            return {
                ...state,
                events: addEvent
                    ? state.events
                          .filter((e) => e.eventId !== eventId)
                          .concat([{ eventId }])
                          .sort(eventsSort)
                    : state.events,
                hash: {
                    ...state.hash,
                    [eventId]: addEvent && lookupHashForBookmark(eventId)
                }
            };
        }

        case FETCH: {
            if (action.status === status.SUCCESS && !!action.data) {
                const bookmarks = action.data;
                return {
                    hash: lookupHashForBookmarks(action.data),
                    events: bookmarks
                        .map((bookmark) => bookmark)
                        .sort(eventsSort),
                    loading: false
                };
            }

            return { ...state, loading: action.status === status.REQUEST };
        }

        case FILTER_UNBOOKMARKED: {
            return {
                ...state,
                events: bookmarkedEvents({ bookmarks: state }).sort(eventsSort)
            };
        }

        case REMOVE_BOOKMARK: {
            const { id } = action.data;
            return {
                ...state,
                hash: {
                    ...state.hash,
                    [id]: false
                },
                events: state.events.filter((event) => event.eventId !== id)
            };
        }

        case AUTH_INVALIDATE:
        case CLEAR_BOOKMARKS: {
            return initialState;
        }

        default: {
            return state;
        }
    }
};
